module.exports = __webpack_public_path__ + "static/img/pro-icon-3.3a52e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/pro-icon-3.jpg
// module id = xx1c
// module chunks = 13